import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.elements'),
    id: 'elements',
    sidebar: [
        {
            id: 'PortionsType',
            label: i18n.tc('configuration.sections.portion', 2),
            icon: 'icon-block',
            routeName: 'PortionsType',
            hasChildren: false
        },
        {
            id: 'SubportionsType',
            label: i18n.tc('configuration.sections.subportion', 2),
            icon: 'icon-porta',
            routeName: 'SubportionsType',
            hasChildren: false
        }
    ]
}
